import React, { Component } from "react";
import { message, Row, Col, Checkbox, Upload, Spin, Select, AutoComplete } from "antd";
import { ColorPicker } from "antd5";
import { Form, FormItem, InputItem, ModalItem, SelectItem, ButtonItem, ErrorItem, TextAreaItem } from "../../../../Components/Items";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import axios from "axios";
import { connect } from "react-redux";
import { UploadOutlined, PictureOutlined, BgColorsOutlined } from "@ant-design/icons";

const { Option } = Select

const COLORES_INSTITUCIONALES = [
  { name: "colorPrimario", label: "Primario", tooltip: "Color principal de la marca: títulos, portadas y elementos destacados." },
  { name: "colorSecundario", label: "Secundario", tooltip: "Color de apoyo: subtítulos, bloques y gráficas." },
  { name: "colorTerciario", label: "Terciario", tooltip: "Tercer color de la marca: detalles, íconos o series adicionales en gráficas." },
  { name: "colorFondo", label: "Fondo", tooltip: "Color de fondo de diapositivas y documentos." },
  { name: "colorTexto", label: "Texto", tooltip: "Color del texto principal." },
]

const TIPOGRAFIAS_SUGERIDAS = [
  "Montserrat", "Roboto", "Open Sans", "Lato", "Poppins", "Inter", "Raleway", "Nunito", "Mulish", "Source Sans 3", "Playfair Display", "Merriweather", "Arial", "Calibri",
].map((value) => ({ value }))

const GUIA_ESTILO_SUGERIDA = [
  "Portada y diapositivas de sección: fondo con el color primario, título en blanco y el logo en la esquina superior derecha.",
  "Diapositivas de contenido: fondo con el color de fondo, títulos en color primario y texto en el color de texto.",
  "Gráficas: primera serie en color primario, segunda en secundario y tercera en terciario.",
  "Cifras clave y datos destacados en color secundario y en negritas.",
  "Estilo limpio y corporativo: mucho espacio en blanco, máximo 5 viñetas por diapositiva, sin degradados ni sombras.",
].join("\n")

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

class GeneralConfiguracion extends Component {
  formRef = React.createRef();
  state = {
    archivo: null,
    base64: null,
    archivosLogo: [],
    rfc: '',
    modalRfc: false,
    dataRfc: null,
    loading: false
  };
  componentDidMount() {
    this.consultarConfiguracion();
  }
  normColor = (color) => {
    if (!color) return null;
    if (typeof color === "string") return color;
    if (color.cleared) return null;
    if (typeof color.toHexString === "function") return color.toHexString();
    return null;
  };
  normIdentidad(identidad) {
    const datos = identidad || {};
    const resultado = {
      tipografia: datos.tipografia ? String(datos.tipografia).trim() : null,
      guiaEstilo: datos.guiaEstilo ? String(datos.guiaEstilo).trim() : null,
    };
    COLORES_INSTITUCIONALES.forEach(({ name }) => {
      resultado[name] = this.normColor(datos[name]);
    });
    return resultado;
  }
  onFinish(values) {
    let fd = new FormData();
    fd.append("empresaId", this.props.empresaId);
    for (var key in values) {
      if (key === "identidadInstitucional") {
        fd.append(key, JSON.stringify(this.normIdentidad(values[key])));
      } else if(values[key] !== null) {
        fd.append(key, values[key]);
      }
    }
    if (this.state.archivo) {
      fd.append("logo", this.state.archivo)
    }
    if (values.rfc !== this.state.rfc) {
      this.setState({
        modalRfc: true,
        dataRfc: values
      })
    } else {
      this.setState({ loading: true })
      axios
        .post(
          "empresas/editarConfiguracionGeneral",
          fd,
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false })
          if (res.data.success === 2) {
            message.success("Se ha modificado la configuracion de la empresa");
            this.consultarConfiguracion();
          } else if (res.data.success === 1) {
            message.error(res.data.message || "No se pudo modificar la configuracion");
          } else {
            message.error("Hubo un error y no se modifico la configuracion");
          }
        });
    }
  }
  onFinishRfc(values) {
    let fd = new FormData();
    fd.append("empresaId", this.props.empresaId);
    for (var key in values) {
      if (key === "identidadInstitucional") {
        fd.append(key, JSON.stringify(this.normIdentidad(values[key])));
      } else if(values[key] !== null) {
        fd.append(key, values[key]);
      }
    }
    if (this.state.archivo) {
      fd.append("logo", this.state.archivo)
    }
    axios
      .post(
        "empresas/editarConfiguracionGeneral",
        fd,
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Se ha modificado la configuracion de la empresa");
          this.consultarConfiguracion();
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se pudo modificar la configuracion");
        } else {
          message.error("Hubo un error y no se modifico la configuracion");
        }
      });
  }
  async consultarConfiguracion() {
    this.setState({ loading: true })
    await axios
      .post("paises/selectPaises", null, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasPaises: res.data });
          this.setState({
            objetoPaises: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post("estados/selectEstados", null, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasEstados: res.data });
          this.setState({
            objetoEstados: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "empresas/selectConfiguracionGeneral",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro configuracion de esta empresa");
        } else {
          if (res.data.logo) {
            let mimetype =
              res.data.logo.extension !== "pdf"
                ? "image/" + res.data.logo.extension
                : "application/pdf";
            const base64 = "data:" + mimetype + ";base64," + res.data.logo.base64;
            this.setState({
              base64
            })
          }
          this.setState({ rfc: res.data.rfc })
          if (res.data.estadoId) {
            this.onChangeEstado(res.data.estadoId)
          }
          if (res.data.municipioId) {
            this.onChangeMunicipio(res.data.municipioId)
          }
          this.formRef.current.setFieldsValue({
            ...res.data
          });
        }
      });
    this.setState({ loading: false })
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  async onChangeArchivo(e) {
    if (e.file.type === 'image/jpeg' || e.file.type === 'image/png') {
      const base64 = await getBase64(e.file);
      this.setState({ archivo: e.file, base64 });
    } else {
      message.error('El archivo debe ser una imagen')
    }
  }
  onChangeEstado(value) {
    this.formRef.current.setFieldsValue({
      municipioId: undefined,
      coloniaId: undefined,
    });
    this.setState({ objetoMunicipios: null, objetoColonias: null });
    axios
      .post(
        "municipios/selectMunicipios",
        { estadoId: value },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasMunicipios: res.data });
          this.setState({
            objetoMunicipios: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
  }
  onChangeMunicipio(value) {
    this.formRef.current.setFieldsValue({ coloniaId: undefined });
    this.setState({ objetoColonias: null });
    axios
      .post(
        "colonias/selectColonias",
        { municipioId: value },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasColonias: res.data });
          this.setState({
            objetoColonias: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.cp + " - " + value.nombre}
                </Option>
              );
            }),
          });
        }
      });
  }
  render() {
    return (
      <>
        <Spin spinning={this.state.loading}>
          <Form
            name="generalConfiguracion"
            layout
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
            ref={this.formRef}
          >
            <Row gutter={[16, 0]}>
              {/* Columna izquierda: Datos + Dirección */}
              <Col xs={24} md={12}>
                <Row>
                <DynamicCardForm
                  title="Datos de la Empresa"
                  style={{
                    maxWidth: '98%',
                    margin: '0 auto 12px auto'
                  }}
                >
                  <Row gutter={[16, 0]}>
                    <Col xs={24}>

                      <FormItem
                        label="RFC"
                        name="rfc"
                        rfc
                        max={200}
                        min={5}
                        margin
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 14 }}
                      >
                        <InputItem placeholder="Registro Federal de Contribuyentes" />
                      </FormItem>

                      <FormItem
                        label="Nombre Comercial"
                        name="nombreComercial"
                        pattern
                        max={200}
                        min={2}
                        margin
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 14 }}
                      >
                        <InputItem placeholder="Nombre Comercial" />
                      </FormItem>

                      <FormItem
                        label="Nombre de Acceso"
                        name="nombreAcceso"
                        pattern
                        max={100}
                        min={2}
                        margin
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 14 }}
                        tooltip="Identificador único de la empresa para el acceso desde la app móvil. No puede repetirse aunque cambien mayúsculas o minúsculas."
                      >
                        <InputItem placeholder="Ej: mi-empresa" />
                      </FormItem>

                      <FormItem
                        label="Nombre / Razón Social"
                        name="nombre"
                        pattern
                        required
                        max={200}
                        min={2}
                        margin
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 14 }}
                      >
                        <InputItem placeholder="Nombre o Razón Social" />
                      </FormItem>
                       <FormItem
                        name="persona"
                        label="Persona Moral"
                        valuePropName="checked"
                        margin
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 14 }}
                      >
                        <Checkbox />
                      </FormItem>

                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const persona = getFieldValue("persona");

                          if (!persona) {
                            return (
                              <>
                                <FormItem
                                  label="Apellido Paterno"
                                  name="apellidoPaterno"
                                  pattern
                                  max={200}
                                  min={2}
                                  margin
                                  labelCol={{ span: 8 }}
                                  wrapperCol={{ span: 14 }}
                                >
                                  <InputItem placeholder="Apellido Paterno" />
                                </FormItem>

                                <FormItem
                                  label="Apellido Materno"
                                  name="apellidoMaterno"
                                  pattern
                                  max={200}
                                  min={2}
                                  margin
                                  labelCol={{ span: 8 }}
                                  wrapperCol={{ span: 14 }}
                                >
                                  <InputItem placeholder="Apellido Materno" />
                                </FormItem>
                              </>
                            );
                          }
                          return null;
                        }}
                      </FormItem>


                    </Col>
                  </Row>
                </DynamicCardForm>
               
                </Row>
              </Col>

              <Col xs={24} md={12} lg ={12} >
              <DynamicCardForm
                title="Dirección Fiscal"
                style={{
                  maxWidth: '100%',
                }}
              >
                <Row gutter={[16, 0]}>

                  {/* FILA 1 */}
                  <Col xs={24} md={12}>
                    <FormItem label="País" name="paisId" required margin
                      labelCol={{ span: 8 }} wrapperCol={{ span: 12 }}>
                      <SelectItem placeholder="País">
                        {this.state.objetoPaises}
                      </SelectItem>
                    </FormItem>
                  </Col>

                  <Col xs={24} md={12}>
                    <FormItem label="Colonia" name="coloniaId" required margin
                      labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                      <SelectItem placeholder="Colonia">
                        {this.state.objetoColonias === null ? (
                          <Option disabled>Elija primero un municipio</Option>
                        ) : (
                          this.state.objetoColonias
                        )}
                      </SelectItem>
                    </FormItem>
                  </Col>

                  {/* FILA 2 */}
                  <Col xs={24} md={12}>
                    <FormItem label="Estado" name="estadoId" required margin
                      labelCol={{ span: 8 }} wrapperCol={{ span: 12 }}>
                      <SelectItem
                        placeholder="Estado"
                        onChange={this.onChangeEstado.bind(this)}
                      >
                        {this.state.objetoEstados}
                      </SelectItem>
                    </FormItem>
                  </Col>

                  <Col xs={24} md={12}>
                    <FormItem label="Calle" name="calle" max={200} margin pattern
                      labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                      <InputItem placeholder="Calle" />
                    </FormItem>
                  </Col>

                  {/* FILA 3 */}
                  <Col xs={24} md={12}>
                    <FormItem label="Municipio" name="municipioId" required margin
                      labelCol={{ span: 8 }} wrapperCol={{ span: 12 }}>
                      <SelectItem
                        placeholder="Municipio"
                        onChange={this.onChangeMunicipio.bind(this)}
                      >
                        {this.state.objetoMunicipios === null ? (
                          <Option disabled>Elija primero un estado</Option>
                        ) : (
                          this.state.objetoMunicipios
                        )}
                      </SelectItem>
                    </FormItem>
                  </Col>

                  <Col xs={24} md={12}>
                    <Row gutter={8}>
                      <Col span={12}>
                        <FormItem label="Núm. Ext." name="numeroCalle" margin
                          labelCol={{ style: { width: 70 } }} wrapperCol={{ style: { flex: 1 } }}>
                          <InputItem placeholder="Exterior" numeroCalle />
                        </FormItem>
                      </Col>

                      <Col span={12}>
                        <FormItem label="Núm. Int." name="numeroInterior" margin pattern
                          labelCol={{ style: { width: 70 } }} wrapperCol={{ style: { flex: 1 } }}>
                          <InputItem placeholder="Interior" />
                        </FormItem>
                      </Col>
                    </Row>
                  </Col>

                </Row>

              </DynamicCardForm>
            </Col>
             {/* Columna derecha: Logo */}
              <Col xs={24} md={12}>
                <Row>
                  <DynamicCardForm
                    title={<><PictureOutlined style={{ color: '#00BFD6', marginRight: 8 }} /> Logo de la Empresa</>}
                    style={{
                        maxWidth: '98%',   
                        margin: '0 auto 12px auto' ,
                      }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div
                        style={{
                          width: '100%',
                          maxWidth: 300,
                          height: 200,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '2px dashed #d9d9d9',
                          borderRadius: 10,
                          background: '#fafafa',
                          marginBottom: 14,
                          overflow: 'hidden',
                        }}
                      >
                        {this.state.base64 ? (
                          <img
                            src={this.state.base64}
                            alt="logo"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'contain',
                              padding: 8,
                            }}
                          />
                        ) : (
                          <div style={{ textAlign: 'center', color: '#bfbfbf' }}>
                            <PictureOutlined style={{ fontSize: 36, marginBottom: 6 }} />
                            <p style={{ margin: 0, fontSize: 12 }}>Sin logo registrado</p>
                          </div>
                        )}
                      </div>
                      <FormItem name="logo" style={{ marginBottom: 0 }}>
                        <Upload
                          accept='image/*'
                          showUploadList={{
                            showRemoveIcon: false,
                            showPreviewIcon: false,
                          }}
                          fileList={this.state.archivosLogo}
                          customRequest={this.onChangeArchivo.bind(this)}
                        >
                          <ButtonItem blanco icon={<UploadOutlined />}>Subir logo</ButtonItem>
                        </Upload>
                      </FormItem>
                      <p style={{ margin: '6px 0 0', fontSize: 11, color: '#999' }}>Recomendación: 80px x 80px (JPG/PNG)</p>
                    </div>
                  </DynamicCardForm>
                </Row>
              </Col>

              <Col xs={24} md={12}>
                <DynamicCardForm
                  title={<><BgColorsOutlined style={{ color: '#00BFD6', marginRight: 8 }} /> Imagen Institucional</>}
                  style={{
                    maxWidth: '100%',
                    margin: '0 auto 12px auto',
                  }}
                >
                  <p style={{ margin: '0 0 12px', fontSize: 12, color: '#999' }}>
                    Paleta de colores y tipografía que usan los asistentes de IA (Claude, ChatGPT) al crear presentaciones y documentos de la empresa.
                  </p>
                  <Row gutter={[16, 0]}>
                    {COLORES_INSTITUCIONALES.map(({ name, label, tooltip }) => (
                      <Col xs={24} md={12} key={name}>
                        <FormItem
                          label={label}
                          name={["identidadInstitucional", name]}
                          margin
                          tooltip={tooltip}
                          getValueFromEvent={this.normColor}
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 16 }}
                        >
                          <ColorPicker disabledAlpha format="hex" showText allowClear />
                        </FormItem>
                      </Col>
                    ))}
                    <Col xs={24} md={12}>
                      <FormItem
                        label="Tipografía"
                        name={["identidadInstitucional", "tipografia"]}
                        margin
                        max={100}
                        tooltip="Nombre de la fuente institucional. Se recomienda una de Google Fonts para que la IA pueda usarla."
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                      >
                        <AutoComplete
                          options={TIPOGRAFIAS_SUGERIDAS}
                          placeholder="Ej: Montserrat"
                          allowClear
                          filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24}>
                      <FormItem
                        label="Guía de estilo"
                        name={["identidadInstitucional", "guiaEstilo"]}
                        margin
                        max={3000}
                        tooltip="Instrucciones que la IA debe seguir al diseñar: dónde va cada color, estilo, tono y composición. Si se deja vacía, la IA decide el diseño."
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 20 }}
                      >
                        <TextAreaItem
                          autoSize={{ minRows: 4, maxRows: 10 }}
                          placeholder="Ej: Portada con fondo en color primario y título en blanco; gráficas con primario, secundario y terciario en ese orden..."
                        />
                      </FormItem>
                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <ButtonItem
                          blanco
                          size="small"
                          onClick={() => this.formRef.current.setFieldsValue({ identidadInstitucional: { guiaEstilo: GUIA_ESTILO_SUGERIDA } })}
                        >
                          Usar guía sugerida
                        </ButtonItem>
                      </div>
                    </Col>
                  </Row>
                </DynamicCardForm>
              </Col>

            </Row>

            <div style={{display: 'flex', justifyContent: 'flex-end',padding: '12px 8px',borderTop: '1px solid #f0f0f0',flexShrink: 0}}>
                <ButtonItem
                    cyan
                    type="primary"
                    htmlType="submit"
                    style={{
                        minWidth: 120,
                        height: 30,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    Guardar Configuración
                </ButtonItem>
            </div>
          </Form>

          <ModalItem
            title="Confirmacion"
            visible={this.state.modalRfc}
            onCancel={() => this.setState({ modalRfc: false, dataRfc: null })}
            onOk={() => {
              this.setState({ modalRfc: false, dataRfc: null });
              this.onFinishRfc(this.state.dataRfc);
            }}
            spinning={false}
            footer
          >
            <h1 style={{ textAlign: "center" }}>Si cambia el RFC ya no podrá facturar, hasta que verifique los certificados nuevamente.</h1>
          </ModalItem>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(GeneralConfiguracion);
